import React, { useEffect, useId, useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker, { CalendarContainer } from 'react-datepicker';
import moment from 'moment/moment';
import useEventCallback from '../../../../../utils/hooks/useEventCallback';
import { ReactComponent as CalendarSvg } from '../../../../../assets/icons/calendar.svg';
import { ReactComponent as ClearSvg } from '../../../../../assets/icons/close.svg';

const thisMonth = moment().format('yyyy-MM');

const RangeQuarterPicker = ({
  startDate, endDate, onChange, size = 'default', hideClearButton, defaultThisMonth,
}) => {
  const uniqId = useId();

  const [isCalendarOpen, calendarToggle] = useState(false);

  const closeHandler = useEventCallback((e) => {
    if (!e.target.closest(`[data-id="calendar_${uniqId}"]`) && isCalendarOpen) {
      calendarOpen(false);
    }
  }, [isCalendarOpen]);

  useEffect(() => {
    window.addEventListener('click', closeHandler, true);

    return () => {
      window.removeEventListener('click', closeHandler, true);
    };
  }, []);

  const onChangeMonth = (d) => {
    onChange([moment(d[0]).format('yyyy-MM'), d[1] ? moment(d[1]).format('yyyy-MM') : null]);

    if (d[1]) calendarOpen(false);
  };
  const calendarOpen = (toggle) => {
    calendarToggle(toggle);
  };

  const calendarContainer = ({ className, children }) => (
    <div className="month_piker_wrapper">
      <CalendarContainer className={className}>
        <div style={{ position: 'relative' }}>{children}</div>
      </CalendarContainer>
    </div>
  );

  return (
    <div data-id={`calendar_${uniqId}`} className={`calendar_wrapper ${size}`}>
      <DatePicker
        customInput={(
          <div className="month_custom_input_wrapper">
            <button
              className={`calendar_custom_input ${isCalendarOpen ? 'active' : ''}`}
              onClickCapture={() => calendarOpen(!isCalendarOpen)}
              type="button"
            >
              <CalendarSvg className="calendar_icon" />

              <div>
                {startDate
                  ? (
                    <span>
                      {`${moment(startDate, 'yyyy-MM').format('YYYY [Q]Q')} ${endDate ? ` - ${moment(endDate, 'yyyy-MM').format('YYYY [Q]Q')}` : ''}`}
                    </span>
                  )

                  : <span style={{ color: '#949292' }}>yyyy q</span>}
              </div>

              <div
                className={`calendar_custom_input_arrow ${isCalendarOpen ? 'open' : ''}`}
              />
            </button>

            {startDate && !hideClearButton && (
              <ClearSvg
                className="clear_svg"
                onClick={() => onChange(defaultThisMonth ? [thisMonth] : [])}
              />
            )}
          </div>
        )}
        selected={startDate ? new Date(moment(startDate, 'yyyy-MM')) : null}
        startDate={startDate ? new Date(moment(startDate, 'yyyy-MM')) : null}
        endDate={endDate ? new Date(moment(endDate, 'yyyy-MM')) : null}
        onChange={onChangeMonth}
        calendarContainer={calendarContainer}
        dateFormat="yyyy, QQQ"
        showQuarterYearPicker
        selectsRange
      />
    </div>
  );
};

RangeQuarterPicker.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  hideClearButton: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'small']),
};

export default RangeQuarterPicker;
